// extracted by mini-css-extract-plugin
export var container = "_sr-0";
export var inputWidth = "_sr-1";